__turbopack_context__.v({
  "asset": "Vg3Cea_asset",
  "back": "Vg3Cea_back",
  "canvas": "Vg3Cea_canvas",
  "canvasOut": "Vg3Cea_canvasOut",
  "fadeIn": "Vg3Cea_fadeIn",
  "front": "Vg3Cea_front",
  "slot": "Vg3Cea_slot",
  "stage": "Vg3Cea_stage",
  "stageFadeIn": "Vg3Cea_stageFadeIn",
  "video": "Vg3Cea_video",
  "videoFrame": "Vg3Cea_videoFrame",
  "videoOn": "Vg3Cea_videoOn",
});
